import { Insomnia } from '@ionic-native/insomnia'

// 设置屏幕常亮
export const insomnia = {
    on() { Insomnia.keepAwake() },
    off() { Insomnia.allowSleepAgain() },
}